import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandVultr({
    height = 28,
    width = 44,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-vultr-brand-logo'
                    : 'provider-vultr-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandVultr"
            width={width}
        />
    );
}

export default AppLogoBrandVultr;
